const MAX_COPILOT_PATH_LENGTH = 200
const PATH_PATTERN = /^\/[\w./~%-]*$/

// The path goes into the prompt, so anything beyond a plain pathname is dropped.
export function sanitizeCopilotPath(path: unknown): string | null {
	if (typeof path !== "string") return null
	const pathname = path.split(/[?#]/)[0] ?? ""
	if (!PATH_PATTERN.test(pathname)) return null
	return pathname.slice(0, MAX_COPILOT_PATH_LENGTH)
}
